import { useMediaQuery } from '@mui/material';

// Le seul bloc prefers-reduced-motion du projet est dans src/App.css,
// fichier qui n'est importé nulle part et donc inerte. On refait le travail ici.
export const useReduceMotion = (): boolean =>
  useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });

/**
 * d(400) vaut 400 ms normalement, 0 sous prefers-reduced-motion.
 * À utiliser pour TOUTES les durées du module, sans exception.
 */
export const useDurees = () => {
  const reduce = useReduceMotion();
  return { reduce, d: (ms: number) => (reduce ? 0 : ms) };
};
